import {arrayMove} from '@dnd-kit/sortable';

function getDragDepth(offset, indentationWidth) {
    return Math.round(offset / indentationWidth);
}

const findContainer = (items, id) => {
    if (id in items) {
        return id;
    }
    return Object.keys(items).find((key) => items[key].includes(id));
};

export function getProjection(
        flatItems,
        items,
        activeId,
        overId,
        dragOffset,
        indentationWidth = 24,
        collapseCount
    ) {
    const debug = true
    let flattenedItems = {}
    let itemIds = []
    Object.keys(items).forEach(containerId => {
        items[containerId].forEach(itemId => {
            flattenedItems[itemId] = flatItems[itemId]
        })
        itemIds.push(...items[containerId].filter(itemId => !flatItems[itemId]['parents'].includes(activeId)))
    })
    const activeItem = flattenedItems[activeId]
    const overItem = flattenedItems[overId]
    const activeContainer = findContainer(items, activeId)
    const overContainer = findContainer(items,overId)

    // const overItemIndex = items[overContainer].filter(itemId => !flattenedItems[itemId]['parents'].includes(activeId)).indexOf(overId);
    // const activeItemIndex = items[activeContainer].filter(itemId => !flattenedItems[itemId]['parents'].includes(activeId)).indexOf(activeId);
    const overItemIndex = itemIds.indexOf(overId)
    const activeItemIndex = itemIds.indexOf(activeId)
    let newItems = arrayMove(Object.values(flattenedItems).filter(item => item && !item['parents'].includes(activeId)), activeItemIndex, overItemIndex);
    let previousItem = newItems[overItemIndex - 1];
    let nextItem = newItems[overItemIndex + 1];
    if(previousItem && previousItem['containerId'] !== overContainer){
        previousItem = null
    }
    if(nextItem && nextItem['containerId'] !== overContainer){
        nextItem = null
    }
    const dragDepth = getDragDepth(dragOffset, indentationWidth);
    const projectedDepth = dragDepth;
    const maxDepth = getMaxDepth({
        previousItem,
    });
    const minDepth = getMinDepth({nextItem});
    let depth = projectedDepth;
    // debug && console.log({overId, activeItemIndex, overItemIndex, activeContainer, overContainer, nextId: nextItem && nextItem['id'], previousId: previousItem && previousItem['id']})
    // console.log({next: nextItem && nextItem['id'], previous: previousItem && previousItem['id'], overIndex: overItemIndex, overContainer, newItems})

    if (projectedDepth >= maxDepth) {
        depth = maxDepth;
    } else if (projectedDepth < minDepth) {
        depth = minDepth;
    }

    return {depth, maxDepth, minDepth, parentId: getParentId()};

    function getParentId() {
        if (depth === 0 || !previousItem) { return null }
        if (depth === previousItem.depth) { return previousItem.parentId }
        if (depth > previousItem.depth) { return previousItem.id }
        const newParent = newItems.slice(0, overItemIndex).reverse().find((item) => item.depth === depth)?.parentId;

        return newParent ?? null;
    }
}

function getMaxDepth({previousItem}) {
    if (previousItem) {
        return previousItem.depth + 1;
    }

    return 0;
}

function getMinDepth({nextItem}) {
    if (nextItem) {
        return nextItem.depth;
    }

    return 0;
}

function flatten(items, parentId = null, depth = 0) {
    return items.reduce((acc, item, index) => {
        return [
            ...acc,
            {...item, parentId, depth, index},
            ...flatten(item.children, item.id, depth + 1),
        ];
    }, []);
}

export function flattenTree(items) {
    return flatten(items);
}

export function buildTree(flattenedItems) {
    const root = {id: 'root', children: []};
    const nodes = {[root.id]: root};
    const items = flattenedItems.map((item) => ({...item, children: []}));

    for (const item of items) {
        const {id, children} = item;
        const parentId = item.parentId ?? root.id;
        const parent = nodes[parentId] ?? findItem(items, parentId);

        nodes[id] = {id, children};
        parent.children.push(item);
    }

    return root.children;
}

export function findItem(items, itemId) {
    return items.find(({id}) => id === itemId);
}

export function findItemDeep(items,itemId) {
    for (const item of items) {
        const {id, children} = item;

        if (id === itemId) { return item}
        if (children.length) {
            const child = findItemDeep(children, itemId);
            if (child) { return child }
        }
    }

    return undefined;
}

export function removeItem(items, id) {
    const newItems = [];
    for (const item of items) {
        if (item.id === id) { continue }
        if (item.children.length) { item.children = removeItem(item.children, id) }
        newItems.push(item);
    }
    return newItems;
}

export function setProperty(items, id, property, setter) {
    for (const item of items) {
        if (item.id === id) {
            item[property] = setter(item[property]);
            continue;
        }

        if (item.children.length) {
            item.children = setProperty(item.children, id, property, setter);
        }
    }

    return [...items];
}

function countChildren(items, count = 0) {
    return items.reduce((acc, {children}) => {
        if (children.length) {
            return countChildren(children, acc + 1);
        }

        return acc + 1;
    }, count);
}

export function getChildCount(items, id) {
    if (!id) {
        return 0;
    }

    const item = findItemDeep(items, id);

    return item ? countChildren(item.children) : 0;
}

export function removeChildrenOf(items, ids) {
    const excludeParentIds = [...ids];

    return items.filter((item) => {
        if (item.parentId && excludeParentIds.includes(item.parentId)) {
            if (item.children.length) { excludeParentIds.push(item.id) }
            return false;
        }

        return true;
    });
}